import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListCreditDecisionsInput } from "@nexxt/contracts/sales";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the credit decisions (pattern.md §10): of a customer, its orders included, or of one order. Under
// the key of the sales orders, so a decision recorded and every write on an order read them again.

const decisions = api.sales["credit-decisions"];

type ListPage = InferResponseType<typeof decisions.$get, 200>;
export type CreditDecision = ListPage["items"][number];

/** The filters of the list input (`listCreditDecisionsInput`), without the paging the queries add. */
export type CreditFilters = Pick<ListCreditDecisionsInput, "customer" | "forSalesOrder">;

const PAGE_SIZE = 50;

const keys = {
  all: ["sales-orders", "credit"] as const,
};

export const creditQueries = {
  ...keys,

  /** Latest decided first. */
  list: (filters: CreditFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          decisions.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
